<template>
  <megabit-base-dialog :show-dialog="true" :width="800">
    <template v-slot:body>
      <v-sheet v-if="isLoading" class="pa-3" dark>
        <v-skeleton-loader
          class="mx-auto"
          :max-width="800"
          max-height="768"
          type="card"
        ></v-skeleton-loader>
      </v-sheet>
      <v-card v-else dark>
        <v-card-title class="align-self-center">
          <span class="text-h6">Cadastro de Plano de Contas (alt+r)</span>
        </v-card-title>
        <v-card-text>
          <v-tabs>
            <v-tab>Dados</v-tab>
            <v-tab-item>
              <v-card dark>
                <v-card-text>
                  <v-row dense>
                    <v-col>
                      <v-form ref="form" v-model="formValid">
                        <v-row dense>
                          <v-col
                            cols="4"
                            md="4"
                            lg="2"
                            style="min-width: 100px max-width: 100%"
                            class="flex-grow-0 flex-shrink-0"
                          >
                            <c-input
                              label="Código"
                              placeholder="Código"
                              :maxLength="6"
                              v-model.trim="form.codigo"
                            />
                          </v-col>
                          <v-col
                            cols="5"
                            md="5"
                            lg="3"
                            style="min-width: 130px max-width: 100%"
                            class="flex-grow-0 flex-shrink-1"
                          >
                            <c-input
                              label="Código Contábil"
                              placeholder="Código Contábil"
                              :maxLength="8"
                              v-model.trim="form.codigoContabil"
                            />
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col
                            cols="6"
                            sm="4"
                            md="4"
                            lg="3"
                            class="flex-grow-0 flex-shrink-0"
                          >
                            <c-input-mask
                              label="Classificação"
                              placeholder="Digite a Classificação"
                              :minLength="1"
                              :isRequired="true"
                              :inputMask="'#.##.##.###.###'"
                              v-model.trim="form.classificacao"
                            />
                          </v-col>
                          <v-col cols="12" md="6" lg="9">
                            <c-input
                              label="Descrição"
                              placeholder="Digite a Descrição"
                              :maxLength="80"
                              :minLength="3"
                              :isRequired="true"
                              v-model.trim="form.nome"
                            />
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col sm="4" md="4" lg="3">
                            <c-select
                              item-text="cifrao"
                              item-value="index"
                              rotulo="Moeda"
                              :clearable="false"
                              :lista="currencySystemList"
                              :item.sync="form.moeda"
                              v-model="form.moeda"
                            />
                          </v-col>
                          <v-col sm="4" md="4" lg="3">
                            <c-select
                              item-text="TIPO"
                              item-value="TIPO"
                              hint="Tipo"
                              rotulo="Tipo"
                              :lista="accountTypeList"
                              :item.sync="form.tipo"
                            />
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col sm="4" md="4" lg="3">
                            <c-input-date
                              label="Bloqueio a partir"
                              v-model.trim="form.dataBloqueio"
                            />
                          </v-col>
                          <v-col cols="2">
                            <c-input
                              label="Dias"
                              placeholder="Dias"
                              :maxLenght="6"
                              style="width:60px"
                              v-model.trim="form.dias"
                            />
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col sm="4" md="4" lg="3">
                            <c-select
                              item-text="text"
                              item-value="value"
                              rotulo="Consolidada"
                              :lista="optionsConsolidada"
                              :item.sync="form.consolidada"
                              v-model="form.consolidada"
                            />
                          </v-col>
                          <v-col>
                            <c-input
                              v-if="
                                form.consolidada
                                  ? form.consolidada.value == 'F'
                                  : false
                              "
                              v-model.trim="form.consolidaFiliais"
                              label="Filiais"
                              placeholder="Filiais ex: 1,3,5,6"
                            />
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col sm="4" md="4" lg="3">
                            <c-select
                              item-text="text"
                              item-value="value"
                              rotulo="Apura Custo?"
                              :lista="optionsApuraCusto"
                              :item.sync="form.isApuraCusto"
                              v-model="form.isApuraCusto"
                            />
                          </v-col>
                          <v-col>
                            <c-select
                              item-text="DESCRICAO"
                              item-value="CODIGO"
                              :lista="accountList"
                              rotulo="Conta Despesa Cobrança"
                              :item.sync="form.contaDespesaCobranca"
                              v-model="form.contaDespesaCobranca"
                            />
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab>Usuários Liberados</v-tab>
            <v-tab-item>
              <v-card dark>
                <v-card-text>
                  <v-row dense>
                    <v-col cols="12" sm="5" md="5" lg="6">
                      <c-select
                        item-text="DESCRICAO"
                        item-value="CODIGO"
                        rotulo="Usuário"
                        :lista="usersList"
                        :item.sync="tabUser.user"
                        v-model="tabUser.user"
                      />
                    </v-col>
                    <v-col cols="9" sm="5" md="5" lg="4">
                      <c-select
                        item-text="DESCRICAO"
                        item-value="FILIAL"
                        rotulo="Filial"
                        :lista="systemList"
                        :item.sync="tabUser.system"
                        v-model="tabUser.system"
                      />
                    </v-col>
                    <v-col>
                      <v-btn color="success" @click="addAccountUsers">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12">
                      <c-simple-table
                        :table-header="headerUsuariosLiberados"
                        :table-items="indexedContasUsuario"
                        chave="id"
                        :doDelete="deleteAccountUsers"
                        :doUpdate="updateTabUser"
                        @item-selected="selectItem($event)"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab>Filiais Liberadas</v-tab>
            <v-tab-item>
              <v-card dark>
                <v-card-text>
                  <v-row dense>
                    <v-col cols="10" sm="4" md="4" lg="4">
                      <c-select
                        item-text="DESCRICAO"
                        item-value="FILIAL"
                        rotulo="Filial"
                        :lista="systemList"
                        :item.sync="tabSystems.system"
                        v-model="tabSystems.system"
                      />
                    </v-col>
                    <v-col cols="1">
                      <v-btn color="success" @click="addAccountSystem">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12">
                      <c-simple-table
                        :table-header="headerFiliaisLiberadas"
                        :table-items="indexedContasFilial"
                        chave="id"
                        :doDelete="deleteAccountSystem"
                        :doUpdate="updateTabSystem"
                        @item-selected="selectItem($event)"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
        <form-buttons 
          @goBack="goBack()"
          @submitForm="submitForm()"
        />
      </v-card>
    </template>
  </megabit-base-dialog>
</template>

<script>
// componentes
// import { mascaraPlanoContas } from "@/utils/utils"

import MegabitBaseDialog from '@/components/shared/base-dialog/BaseDialog'
import cSimpleTable from '@/components/shared/table/TableSemRota'
import cSelect from '@/components/shared/base-input/BaseSelect.vue'
import cInputMask from '@/components/shared/base-input/BaseInputMask.vue'
import cInput from '@/components/shared/base-input/BaseInput.vue'
import cInputDate from '@/components/shared/base-input/BaseInputDate.vue'
import FormButtons from '@/components/shared/base-buttons/FormButtons'

import { formRegisterMixin } from '@/mixins/component/form/FormRegisterMixin'
import { tableMixin } from '@/mixins/component/table/TableMixin'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'FormRegisterPlanoContas',
  mixins: [formRegisterMixin, tableMixin],
  components: {
    cSelect,
    cInput,
    cInputDate,
    cInputMask,
    cSimpleTable,
    MegabitBaseDialog,
    FormButtons
  },

  data: () => ({
    isLoading: true,
    optionsConsolidada: [
      { text: 'Sim', value: 'S' },
      { text: 'Não', value: 'N' },
      { text: 'Filiais', value: 'F' },
    ],
    optionsApuraCusto: [
      { text: 'Sim', value: 'S' },
      { text: 'Não', value: 'N' },
    ],

    form: {
      codigo: null,
      nome: null,
      classificacao: null,
      dataBloqueio: null,
      codigoContabil: null,
      tipo: null,
      dias: null,
      moeda: {},
      consolidada: null,
      consolidaFiliais: null,
      isApuraCusto: null,
      contasFilial: [],
      contasUsuario: [],
      contaDespesaCobranca: null,
    },

    tabUser: {
      user: '',
      system: '',
    },

    tabSystems: {
      system: '',
    },

    isUpdate: false,
    formValid: false,
  }),

  computed: {
    ...mapGetters({
      companyTypeList: 'companyTypeModule/getComboBoxGrupoList',
      accountList: 'accountsModule/getComboBoxList',
      accountTypeList: 'accountsModule/getAccountTypeList',
      currencySystemList: 'systemModule/getSystemCurrencies',
      systemList: 'systemModule/getSystems',
      usersList: 'userModule/getUsersList',
    }),

    indexedContasUsuario() {
      return this.form.contasUsuario.map((item, index) => ({
        ...item,
        id: index,
      }))
    },

    indexedContasFilial() {
      return this.form.contasFilial.map((item, index) => ({
        ...item,
        id: index,
      }))
    },

    headerFiliaisLiberadas() {
      return [
        { text: 'Filial', value: 'FILIAL', width: 100 },
        { text: 'Nome', value: 'NOME', align: 'start' },
        { text: 'Ações', value: 'controls', align: 'right', sortable: false },
      ]
    },
    headerUsuariosLiberados() {
      return [
        { text: 'Usuário', value: 'USUARIO', align: 'start', width: 450 },
        { text: 'Filial', value: 'FILIAL', align: 'start', width: 100 },
        { text: 'Ações', value: 'controls', align: 'right', sortable: false },
      ]
    },
  },
  methods: {
    ...mapActions({
      insert: 'accountsModule/insertAccount',
      update: 'accountsModule/updateAccount',
    }),

    ...mapActions('accountsModule', [
      'getAllAccounts',
      'mixAccountTypes',
      'getAccount',
      'createAccount',
    ]),

    ...mapActions('userModule', ['getUsersAPI']),

    clearFieldsTabUser() {
      this.tabUser.user = undefined
      this.tabUser.system = undefined
    },
    clearFieldsTabSystem() {
      this.tabSystems.system = undefined
    },
    updateTabUser(value) {
      this.deleteAccountUsers(value)
      this.tabUser.user = value.USUARIO
      this.tabUser.system = value.FILIAL
    },
    updateTabSystem(value) {
      this.deleteAccountSystem(value)
      this.tabSystems.system = value
    },

    validateSelect(value, description) {
      let isValid = true

      if (!value) {
        this.$toasted.error(`Selecione ${description} para prosseguir.`);
        isValid = false
      }
      return isValid
    },

    addAccountUsers() {
      if (this.tabUser) {
        if (!this.validateSelect(this.tabUser.user, 'o Usuário')) return

        if (!this.validateSelect(this.tabUser.system, 'a Filial')) return

        let conta = {
          USUARIO: this.tabUser.user.NOME,
          FILIAL: this.tabUser.system.FILIAL,
        }

        let result = this.form.contasUsuario.filter(
          (current) =>
            current.USUARIO == conta.USUARIO && current.FILIAL == conta.FILIAL
        )

        if (result && result.length > 0) {
          this.$toasted.error('Usuário e Filial já estão na lista.');
          return
        }

        this.clearFieldsTabUser()
        this.form.contasUsuario.push(conta)
      }
    },
    addAccountSystem() {
      if (this.tabSystems) {
        if (!this.validateSelect(this.tabSystems.system, 'a Filial')) return

        let system = {
          ...this.tabSystems.system,
        }

        let result = this.form.contasFilial.filter(
          (current) => current.FILIAL == system.FILIAL
        )
        if (result && result.length > 0) {
          this.$toasted.error('Filial já está na lista.');
          return
        }

        this.clearFieldsTabSystem()
        this.form.contasFilial.push(system)
      }
    },

    deleteAccountUsers(value) {
      let contas = this.form.contasUsuario.filter(
        (v) => v.USUARIO !== value.USUARIO && v.FILIAL !== value.FILIAL
      )
      this.form.contasUsuario = contas
    },

    deleteAccountSystem(value) {
      let system = this.form.contasFilial.filter(
        (v) => v.CODIGO !== value.CODIGO
      )
      this.form.contasFilial = system
    },

    async setData() {
      await this.fetch()
      if (this.$route.params) {
        let account = {}
        if (this.$route.params.id > 0) {
          account = await this.getAccount(this.$route.params.id)
          this.isUpdate = !this.isUpdate
        } else {
          account = await this.createAccount(
            this.$route.params.classificacao ?? ''
          )
        }
        this.form = {
          ...account,
        }
      }
      this.loaded = !this.loaded
    },

    async fetch() {
      try {
        if (!this.accountTypeList) await this.mixAccountTypes()

        await this.getAllAccounts({ todos: 'S' })
        await this.getUsersAPI({ todos: 'S' })
      } catch (error) {
        this.$toasted.error(error, {duration: null});
      }
    },
  },
  async created() {
    await this.setData()
    this.isLoading = !this.isLoading
  },
}
</script>

<style lang="scss" scoped></style>
